import { render } from "./ThisIsBeloit.vue?vue&type=template&id=96b1cbe8&scoped=true"
import script from "./ThisIsBeloit.vue?vue&type=script&lang=js"
export * from "./ThisIsBeloit.vue?vue&type=script&lang=js"

import "./ThisIsBeloit.vue?vue&type=style&index=0&id=96b1cbe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b1cbe8"]])

export default __exports__